
















import { Component, Vue } from "vue-property-decorator";

@Component
export default class TechStack extends Vue {
  selectedTechnology = "";

  techStack = [
    { name: "Vue.js", icon: "vuejs" },
    { name: "Javascript", icon: "js" },
    { name: "Github", icon: "github" },
    { name: "Sass", icon: "sass" },
    { name: "Figma", icon: "figma" }
  ];
}
